import React from 'react';
import { connect } from 'react-redux';
import {
  columnDescription,
  columnName,
  columnMultiSelect,
  columnCreatedOn,
  columnCollectionDatasetLastAdded,
  columnCollectionDatasetCount,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import { sortingFilters } from '@/constants/states';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleCollectionsColumnOrderBy, toggleCollectionsSelected } from '../actions';

const CollectionsTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
  columns = [
    columnMultiSelect,
    columnName,
    columnDescription,
    columnCreatedOn,
    columnCollectionDatasetLastAdded,
    columnCollectionDatasetCount,
    columnTools,
  ],
}) => (
  <NameDescriptionColumns
    category={category}
    columns={columns}
    entity="collection"
    items={items}
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
    orderBy={orderBy}
    singleSorting={singleSorting}
  >
    {hasColumn(columns, columnCreatedOn) && (
    <TableSortedColumn
      name={columnCreatedOn}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnCollectionDatasetLastAdded) && (
    <UnsortedColumn columnId={columnCollectionDatasetLastAdded} />
    )}
    {hasColumn(columns, columnCollectionDatasetCount) && (
    <UnsortedColumn columnId={columnCollectionDatasetCount} />
    )}
  </NameDescriptionColumns>
);

const mapStateToProps = (
  { collections: { collections } },
  { category },
) => {
  const { orderBy, singleSorting } = collections[category] || sortingFilters();
  return ({ orderBy, singleSorting });
};

const mapDispatchToProps = {
  onCheckBoxClick: toggleCollectionsSelected,
  onOrderByColumn: toggleCollectionsColumnOrderBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsTableColumns);
